import { render, staticRenderFns } from "./FreeBetsPromo.vue?vue&type=template&id=4e134250&scoped=true"
import script from "./FreeBetsPromo.vue?vue&type=script&lang=js"
export * from "./FreeBetsPromo.vue?vue&type=script&lang=js"
import style0 from "./FreeBetsPromo.vue?vue&type=style&index=0&id=4e134250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e134250",
  null
  
)

export default component.exports